import { FormEvent, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthPageShell } from "../components/AuthPageShell";
import { PasswordInput } from "../components/PasswordInput";
import { apiFetch } from "../api/client";
import { completeAuthRedirect } from "../lib/authRedirect";

export function RegisterPage() {
  const [params] = useSearchParams();
  const ret = params.get("return") || "/cabinet";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr("");
    try {
      await apiFetch("/api/v1/auth/register", {
        method: "POST",
        json: { email: email.trim(), password },
      });
      completeAuthRedirect(ret);
    } catch (ex) {
      setErr(ex instanceof Error ? ex.message : "Ошибка регистрации");
    }
  }

  const qs = params.toString();
  const loginHref = qs ? `/login?${qs}` : "/login";

  return (
    <AuthPageShell loginHref={loginHref}>
      <div className="wb-card__badge wb-card__badge--accent">Сервис доски</div>
      <h1 className="wb-h2">Регистрация</h1>
      <p className="wb-card__intro">
        Аккаунт для внешних пользователей: email и пароль. Старт на тарифе Free (до 3 досок). Если вы
        из онлайн-школы Bezpart — входите через портал школы, не через эту форму.
      </p>
      {err ? (
        <p className="wb-alert wb-alert--error" role="alert">
          {err}
        </p>
      ) : null}
      {/* Подсказки менеджеру паролей обязательны именно здесь: сохранить
          пароль браузер предлагает в момент регистрации, и без них он
          форму не узнавал — сохранять было нечего, а потом нечего и
          подставлять на входе. */}
      <form className="wb-form-stack" method="post" onSubmit={onSubmit}>
        <div className="wb-form-field">
          <label className="wb-label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            name="email"
            className="wb-input"
            type="email"
            required
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="wb-form-field">
          <label className="wb-label" htmlFor="password">
            Пароль
          </label>
          <PasswordInput
            id="password"
            name="password"
            minLength={8}
            required
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className="wb-btn wb-btn--primary wb-btn--lg" type="submit">
          Зарегистрироваться
        </button>
      </form>
      <p className="wb-auth-footer">
        Уже есть аккаунт? <Link to={loginHref}>Войти</Link>
      </p>
    </AuthPageShell>
  );
}
